import { render } from "./TextDark.vue?vue&type=template&id=6b667d4e&scoped=true&bindings={\"size\":\"props\",\"weight\":\"props\",\"align\":\"props\",\"action\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./TextDark.vue?vue&type=script&lang=js"
export * from "./TextDark.vue?vue&type=script&lang=js"

import "./TextDark.vue?vue&type=style&index=0&id=6b667d4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b667d4e"

export default script